<mat-toolbar color="accent">Copy Client Secret</mat-toolbar>

<mat-dialog-content class="flex flex-col gap-4">
  <pr-information-box>
    Your Client Secret has been generated. Please copy the Client Secret from
    below. This will no longer be visible once the dialog is closed.
  </pr-information-box>

  <div class="mt-4 flex flex-col gap-2 p-2">
    <div class="flex items-center gap-2">
      <span>Client Secret: {{ clientSecret }}</span>
      <a href="javascript:void(0);" (click)="copy()">
        <mat-icon matTooltip="Copy Client Secret to clipboard" color="accent"
          >content_copy</mat-icon
        >
      </a>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button type="button" mat-stroked-button mat-dialog-close>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
